import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { EmailTemplateEditorPage } from "@/components/email-templates/email-template-editor-page";
import type { Id } from "@/convex/_generated/dataModel";

// `/settings/email-templates/new?scope=notification&target=invoice_completed` crea;
// `/settings/email-templates/<id>` edita.
const searchSchema = z.object({
  scope: z.enum(["notification", "system_table", "collection", "script"]).optional(),
  target: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/settings/_layout/email-templates/$templateId")({
  validateSearch: searchSchema,
  component: EmailTemplateDetailPage,
});

function EmailTemplateDetailPage() {
  const { templateId } = Route.useParams();
  const { scope, target } = Route.useSearch();
  const id = templateId === "new" ? null : (templateId as Id<"email_templates">);

  return (
    <RouteGuardPermissions permissions={[{ module: "custom_fields", actions: ["read"] }]}>
      <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
        <EmailTemplateEditorPage templateId={id} newScope={scope} newTarget={target} />
      </div>
    </RouteGuardPermissions>
  );
}
